module.exports = __webpack_public_path__ + "static/media/team-health-pool-calendario-mesa-personalizado01-1.0453158b.jpg";